import React from 'react';
import { HeaderOnboarding } from 'UIcomponents';

import styles from './styles.module.scss';

interface IProps {
  children: React.ReactNode;
}

const OnboardingLayout: React.FC<IProps> = ({ children }) => {
  return (
    <div className={styles.root}>
      <HeaderOnboarding />
      {children}
    </div>
  );
};

export default OnboardingLayout;
